<div class="w-100 d-flex flex-column justify-content-center align-items-center">
    <div class="bs-h1 th-text-main mb-3">{{getTitle()}}</div>
    <div class="receipt-container" [ngClass]="{
        'receipt-container-xsm': this.isExtraSmall,
        'receipt-container-md': this.isSmall || this.isMedium
    }">
        <div class="receipt-content">
            <img class="ssvmn-logo" src="/assets/imgs/logo-ssvmn.png"/>
            <ng-container  class="detail" #target></ng-container>
        </div>
        <div class="total">
            <div class="total-container">
                <label class="bs-h3 th-text-main" for="">Monto a pagar:</label>
                <label class="bs-sc-text-title th-text-main" for="">₡{{this.integerPart }}<span class="decimal">.{{ this.decimalPart  }}</span></label>
            </div>
        </div>
    </div>
</div>